'use client';

import * as React from 'react';
import { useState } from 'react';
import Link from 'next/link';
import SmallLogo from '../small_logo';
import SearchModal from '../search_modal';

const NavBar = () => {
    const [isSearchModalOpen, setIsSearchModalOpen] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const handleOpenSearchModal = () => {
        setIsSearchModalOpen(true);
    };

    const handleCloseSearchModal = () => {
        setIsSearchModalOpen(false);
    };

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    return (
        <nav className="w-full py-2 px-4 md:px-10 bg-primary/90 backdrop-blur-sm fixed top-0 left-0 z-50">
            <div className="max-w-7xl mx-auto flex justify-between items-center">
                {/* Logo and Brand */}
                <div className="flex items-center w-10">
                    <SmallLogo />
                </div>

                {/* Desktop Navigation */}
                <div className="hidden md:flex space-x-8 items-center">
                    <Link href="/browse" className="text-white hover:text-purple-300 transition-colors text-sm font-normal">
                        Browse Venues
                    </Link>
                    <Link href="/about" className="text-white hover:text-purple-300 transition-colors text-sm font-normal">
                        About
                    </Link>
                    <Link href="/blog" className="text-white hover:text-purple-300 transition-colors text-sm font-normal">
                        Blog
                    </Link>
                    <Link href="/list_your_venue" className="text-white hover:text-purple-300 transition-colors text-sm font-normal">
                        List Your Venue
                    </Link>
                    <Link href="/contact" className="text-white hover:text-purple-300 transition-colors text-sm font-normal">
                        Contact
                    </Link>
                    <Link href="/login" className="text-white hover:text-purple-300 transition-colors text-sm font-normal ml-2">
                        Log in
                    </Link>
                    <button className="bg-white rounded-full p-2 ml-3" onClick={handleOpenSearchModal}>
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-[#1C1C34]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                        </svg>
                    </button>
                </div>

                {/* Mobile menu button */}
                <div className="md:hidden">
                    <button
                        className="p-2 rounded-md text-white focus:outline-none"
                        onClick={toggleMobileMenu}
                        aria-label="Toggle mobile menu"
                    >
                        {isMobileMenuOpen ? (
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        ) : (
                            <div>
                                <div className="w-6 h-0.5 bg-white mb-1.5"></div>
                                <div className="w-6 h-0.5 bg-white mb-1.5"></div>
                                <div className="w-6 h-0.5 bg-white"></div>
                            </div>
                        )}
                    </button>
                </div>
            </div>

            {/* Mobile Menu */}
            {isMobileMenuOpen && (
                <div className="md:hidden absolute top-full left-0 w-full bg-[#1C1C34] shadow-lg">
                    <div className="flex flex-col divide-y divide-gray-800">
                        <Link href="/browse" className="text-white py-4 px-6 hover:bg-primary/50">
                            Browse Venues
                        </Link>
                        <Link href="/about" className="text-white py-4 px-6 hover:bg-primary/50">
                            About
                        </Link>
                        <Link href="/blog" className="text-white py-4 px-6 hover:bg-primary/50">
                            Blog
                        </Link>
                        <Link href="/list_your_venue" className="text-white py-4 px-6 hover:bg-primary/50">
                            List Your Venue
                        </Link>
                        <Link href="/contact" className="text-white py-4 px-6 hover:bg-primary/50">
                            Contact
                        </Link>
                        <Link href="/login" className="text-white py-4 px-6 hover:bg-primary/50">
                            Log in
                        </Link>
                        <button
                            className="flex items-center text-white py-4 px-6 hover:bg-primary/50 w-full text-left"
                            onClick={handleOpenSearchModal}
                        >
                            Search
                        </button>
                    </div>
                </div>
            )}

            {/* Search Modal */}
            <SearchModal
                isOpen={isSearchModalOpen}
                onClose={handleCloseSearchModal}
            />
        </nav>
    );
};

export default NavBar; 